import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, Slides, Platform, ModalController, AlertController, ToastController } from 'ionic-angular';
import { Task } from '../../model/model';
import { EditTaskPage } from '../edit-task/edit-task';

@IonicPage()
@Component({
  selector: 'page-main',
  templateUrl: 'main.html',
})
export class MainPage {

  @ViewChild('mySlider') slider: Slides;

  public selected = 0;
  public indicator = null;

  tasks: Task[] = [];
  existDone: string = 'false';

  constructor(
    public navCtrl: NavController,
    public platform: Platform,
    public modalCtrl: ModalController,
    private alertCtrl: AlertController,
    private toastCtrl: ToastController
  ) {
    this.platform = platform;
  }

  editTask(i: number) {
    const modal = this.modalCtrl.create(EditTaskPage, { index: i });
    modal.onDidDismiss(() => {
      this.reloadTask();
    });
    modal.present();
  }

  ionViewWillEnter() {
    this.reloadTask();
  }

  reloadTask() {
    if (localStorage.getItem('tasks')) {
      this.tasks = JSON.parse(localStorage.getItem('tasks'));
      this.checkDone();
    }
  }

  saveTask() {
    localStorage.setItem('tasks', JSON.stringify(this.tasks));
    this.checkDone();
  }

  deleteTask() {
    const deleteAlert = this.alertCtrl.create({
      title: 'Delete Completed Tasks',
      buttons: [
        {
          text: 'Cancel',
        },
        {
          text: 'Delete',
          role: 'destructive',
          handler: () => {
            let x: number = 0;
            while (x < this.tasks.length) {
              if (this.tasks[x].done == true) {
                this.tasks.splice(x, 1);
              } else {
                x++;
              }
            }
            localStorage.setItem('tasks', JSON.stringify(this.tasks));
            this.checkDone();
            const deleteToast = this.toastCtrl.create({
              message: 'Deleted Successfully.',
              duration: 2500
            });
            deleteToast.present();
          }
        }
      ]
    });
    deleteAlert.present();
  }

  checkDone() {
    let x: number = 0;
    if (x == this.tasks.length) {
      this.existDone = 'false';
    }
    while (x < this.tasks.length) {
      if (this.tasks[x].done == true) {
        this.existDone = 'true';
        break;
      } else {
        x++;
      }
      this.existDone = 'false';
    }
  }

  // Floating Button Function
  public CreateModal(page) {
    const modal = this.modalCtrl.create(page);
    // reload task data when new tasks made
    modal.onDidDismiss(() => {
      this.reloadTask();
    });
    modal.present();
  }

  // Functions for Slide Tab
  public ChangeStart() {
    let currentIndex = this.slider.getActiveIndex();
    if (currentIndex === 2) {
      this.selected = 2;
      this.indicator.style.webkitTransform = 'translate3d(200%,0,0)';
    }
    if (currentIndex === 1) {
      this.selected = 1;
      this.indicator.style.webkitTransform = 'translate3d(100%,0,0)';
    }
    if (currentIndex === 0) {
      this.selected = 0;
      this.indicator.style.webkitTransform = 'translate3d(0%,0,0)';
    }
  }

  ngAfterViewInit() {
    this.indicator = document.getElementById("indicatorFor3");
    if (this.platform.is('windows')) {
      this.indicator.style.opacity = '0';
    }
  }

  select(index) {
    this.selected = index;
    if (index === 2) {
      this.indicator.style.webkitTransform = 'translate3d(200%,0,0)';
    }
    if (index === 1) {
      this.indicator.style.webkitTransform = 'translate3d(100%,0,0)';
    }
    if (index === 0) {
      this.indicator.style.webkitTransform = 'translate3d(0%,0,0)';
    }
    this.slider.slideTo(index, 500);
  }

  panEvent(e) {
    let currentIndex = this.slider.getActiveIndex();
    if (currentIndex === 2) {
      this.selected = 2;
      this.indicator.style.webkitTransform = 'translate3d(200%,0,0)';
    }
    if (currentIndex === 1) {
      this.selected = 1;
      this.indicator.style.webkitTransform = 'translate3d(100%,0,0)';
    }
    if (currentIndex === 0) {
      this.selected = 0;
      this.indicator.style.webkitTransform = 'translate3d(0%,0,0)';
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/main/main.ts